import apiSlice from "./apiSlice";

const invoiceStatusApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        getAdvancePayment: builder.query({
            query: (req) => ({
                url: `paymenttracker/advance-payment`,
                params: req
            })

        }),

        getInvoiceStatus: builder.query({
            query: ({ projectId, }) => ({
                url: `paymenttracker/invoice-status`,
                params: {
                    projectid: projectId,
                },
            }),
        }),
        getInvoiceStatusByArgs: builder.query({
            query: ({ projectId, vendor }) => ({
                url: `paymenttracker/invoice-status`,
                params: {
                    projectid: projectId,
                    vendor: vendor,
                },
            }),
        }),

        getInvoiceStatusByValue: builder.query({
            query: ({ projectId, }) => ({
                url: `paymenttracker/invoice-status-value?`,
                params: {
                    projectid: projectId,
                }
            })
        }),
        getInvoiceStatusByValueBYArgs: builder.query({
            query: ({ projectId, vendor }) => ({
                url: `paymenttracker/invoice-status-value?`,
                params: {
                    projectid: projectId,
                    vendor: vendor
                }
            })
        }),

        getInvoiceAgeingAnalysis: builder.query({
            query: ({ projectId, ageingType, vendor }) => ({
                url: `paymenttracker/invoice-ageing-analysis`,
                params: {
                    projectid: projectId,
                    ageingType:ageingType,
                    vendor: vendor,
                },
            }),
        }),
    }),
});

export const {
    useGetAdvancePaymentQuery,
    useGetInvoiceStatusQuery,
    useGetInvoiceStatusByValueQuery,
    useGetInvoiceStatusByValueBYArgsQuery,
    useGetInvoiceStatusByArgsQuery,
    useGetInvoiceAgeingAnalysisQuery
} = invoiceStatusApiSlice;
